"use client";

import Image from "next/image";
import { Expand } from "lucide-react";
import { shouldShow } from "@/types/utils";
import { FormatNumberWithSeparator, ConvertToPersianNumbers } from "@/utils/utils";
import AdCard from "@/components/ad-card";

const SupplyCard = ({ ad }: { ad: any }) => {
  const isSold = Boolean(ad.is_sold);

  return (
    <AdCard
      ad={ad}
      media={
        <div className="relative w-full overflow-hidden rounded-xl bg-gray-100 h-40">
          <Image
            src={ad.image || "/assets/imagePlaceholder.png"}
            alt={ad.title || "آگهی مسکن"}
            fill
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 25vw"
            className="object-cover transition-opacity duration-500"
            loading="lazy"
            placeholder="blur"
            blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mN88f7TfwAJBAP6X6u3VAAAAABJRU5ErkJggg=="
          />
          <div className="absolute inset-0 bg-linear-to-t from-black/80 via-25% via-black/5 to-transparent" />
          {isSold ? (
            <div
              aria-hidden
              className="pointer-events-none absolute -left-11 top-5 z-10 w-40 -rotate-45"
            >
              <span className="block border-y-2 border-red-600 bg-white py-1 px-2 text-center text-sm font-bold tracking-wide text-red-600">
                معامله شد
              </span>
            </div>
          ) : (
            shouldShow(ad.listing_type) && (
              <span className="absolute bottom-2 right-3 rounded-sm bg-[#F97066] px-2 py-1 text-sm text-white">
                {ad.listing_type}
              </span>
            )
          )}
        </div>
      }
      pricing={
        <>
          {shouldShow(ad.price) && (
            <div className="text-lg font-extrabold text-indigo-700">
              {ConvertToPersianNumbers(FormatNumberWithSeparator(ad.price))}
              <span className="mr-1 text-xs font-normal text-gray-500">
                تومان
              </span>
            </div>
          )}

          {shouldShow(ad.mortgage_amount) && (
            <div className="text-base font-extrabold text-gray-700">
              <span className="ml-1 text-xs font-normal text-gray-500">
                رهن:
              </span>
              <span className="text-indigo-700">
                {ConvertToPersianNumbers(FormatNumberWithSeparator(ad.mortgage_amount))}
              </span>
              <span className="mr-1 text-xs font-normal text-gray-500">
                تومان
              </span>
            </div>
          )}

          {shouldShow(ad.rent_amount) && (
            <div className="text-base font-extrabold text-gray-700">
              <span className="ml-1 text-xs font-normal text-gray-500">
                اجاره:
              </span>
              <span className="text-indigo-700">
                {ConvertToPersianNumbers(FormatNumberWithSeparator(ad.rent_amount))}
              </span>
              <span className="mr-1 text-xs font-normal text-gray-500">
                تومان
              </span>
            </div>
          )}
        </>
      }
      area={
        shouldShow(ad.total_area) ? (
          <div className="mt-auto pt-3 flex items-center gap-2 text-xs border-t font-medium text-gray-400 border-gray-50">
            <Expand className="h-3.5 w-3.5" />
            {ConvertToPersianNumbers(ad.total_area)} متر مربع
          </div>
        ) : null
      }
    />
  );
};

export default SupplyCard;
